var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit_index"},[(_vm.start)?_c('edit'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }